module.exports = __webpack_public_path__ + "assets/img/type_2.4249d64a.png";